module.exports = __webpack_public_path__ + "img/al1.6bc79d96.png";